import SanityImage from 'gatsby-plugin-sanity-image'
import React from 'react'
import CTALink from '../CTALink'
import PortableText from '../portableText'
import {
	SpotlightAuthorAndCTA,
	SpotlightCopy,
	SpotlightCustomer,
	SpotlightCustomerImage,
	SpotlightCustomerLogo,
	SpotlightLeft,
	SpotlightRight,
	SpotlightWrapper,
} from './Spotlight.styles'

export default function Spotlight({ text, logo, cta, colorlist, customer }) {
	const { name, title, company, image } = customer || {}
	return (
		<SpotlightWrapper>
			<SpotlightLeft>
				<SpotlightCopy>{text && <PortableText blocks={text} />}</SpotlightCopy>
				<SpotlightAuthorAndCTA>
					{customer && (
						<SpotlightCustomer>
							{name ? <p>{name}</p> : null}
							{title ? <p>{title}</p> : null}
							{company ? <p>{company}</p> : null}
						</SpotlightCustomer>
					)}
					{cta && cta.title && <CTALink {...cta} />}
				</SpotlightAuthorAndCTA>
			</SpotlightLeft>
			<SpotlightRight colorlist={colorlist}>
				{image ? (
					<>
						{image.asset ? (
							<SpotlightCustomerImage>
								{image && <SanityImage asset={image.asset} alt={image.alt} {...image} />}
							</SpotlightCustomerImage>
						) : null}
					</>
				) : null}
				{logo ? (
					<>
						{logo.image.asset ? (
							<SpotlightCustomerLogo>
								<SanityImage asset={logo.image.asset} alt={logo.image.alt} {...logo} />
							</SpotlightCustomerLogo>
						) : null}
					</>
				) : null}
			</SpotlightRight>
		</SpotlightWrapper>
	)
}
